<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="model ? update(form.value) : add(form.value)" appPermissionControl="P201F0001">
  <!-- Campo oculto para el ID del usuario (solo para edición) -->
  <input type="hidden" formControlName="id" />

  <div class="form-row">
    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="numeroDocumento" class="form-control"
        [placeholder]="'Número de documento'" appPermissionControl="P201K0016">
      <label>Número de documento</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="email" formControlName="email" class="form-control" [placeholder]="'admin@correo.com'"
        [ngClass]="{'input-error': emailError}" (input)="clearEmailError()"
        appPermissionControl="P201K0002">
      <label>Correo</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="nombre" class="form-control" maxlength="50"
        [placeholder]="'Nombre'" appPermissionControl="P201K0003">
      <label>Nombre</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="phone" class="form-control" maxlength="10"
        (keypress)="keyPressNumbers($event)" [placeholder]="'3121231234'" appPermissionControl="P201K0004">
      <label>Teléfono</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="userName" class="form-control" [placeholder]="'Usuario'"
        maxlength="6" [ngClass]="{'input-error': userNameError}" (input)="clearUserNameError()"
        appPermissionControl="P201K0007">
      <label>Usuario</label>
    </div>

    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="tipoUsuario" [options]="tiposUsuarioOptions" optionLabel="label" optionValue="value"
        [filter]="true" [showClear]="true" appendTo="body" placeholder="Seleccione tipo de usuario" class="w-100"
        appPermissionControl="P201K0008">
      </p-dropdown>
      <label>Tipo de Usuario</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="nivel" class="form-control" [placeholder]="'Nivel'"
        appPermissionControl="P201K0009">
      <label>Nivel</label>
    </div>

    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="idioma" [options]="idiomasOptions" optionLabel="label" optionValue="value"
        [filter]="true" [showClear]="true" appendTo="body" placeholder="Seleccione idioma" class="w-100"
        appPermissionControl="P201K0010">
      </p-dropdown>
      <label>Idioma</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="number" formControlName="lineaAutorizada" class="form-control" [placeholder]="'0.00'"
        step="0.01" min="0" appPermissionControl="P201K0011">
      <label>Línea Autorizada</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="promotorInterno" class="form-control"
        [placeholder]="'Promotor Interno'" appPermissionControl="P201K0012">
      <label>Promotor Interno</label>
    </div>
    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="rolId" [options]="Rols" optionLabel="description" optionValue="id" [filter]="true"
        [showClear]="true" appendTo="body" placeholder="Seleccione un rol" class="w-100"
        appPermissionControl="P201K0005">
      </p-dropdown>
      <label>Rol</label>
    </div>

    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="active" [options]="estadosOptions" optionLabel="label" optionValue="value"
        appendTo="body" placeholder="Seleccione estado" class="w-100" appPermissionControl="P201K0006">
      </p-dropdown>
      <label>Estado</label>
    </div>
  </div>


    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="regional" [options]="regionalesOptions" optionLabel="label" optionValue="value"
        [filter]="true" [showClear]="true" appendTo="body" placeholder="Seleccione regional" class="w-100"
        appPermissionControl="P201K0013">
      </p-dropdown>
      <label>Regional</label>
    </div>

    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="compania" [options]="companiasOptions" optionLabel="label" optionValue="value"
        [filter]="true" [showClear]="true" appendTo="body" placeholder="Seleccione compañía" class="w-100"
        appPermissionControl="P201K0014">
      </p-dropdown>
      <label>Compañía</label>
    </div>

    <div class="form-field flex-grow-1 mt-1">
      <p-dropdown formControlName="sucursal" [options]="sucursalesOptions" optionLabel="label" optionValue="value"
        [filter]="true" [showClear]="true" [disabled]="!form.get('compania')?.value" appendTo="body"
        placeholder="Seleccione sucursal" class="w-100" appPermissionControl="P201K0015">
      </p-dropdown>
      <label>Sucursal</label>
    </div>

  <div class="d-flex gap-4 mb-4">
    <div class="checkbox-field" *ngIf="showAdministradorCheckbox">
      <input type="checkbox" formControlName="administrador" id="administrador">
      <label for="administrador">Administrador</label>
    </div>
    <div class="checkbox-field">
      <input type="checkbox" formControlName="autorizaciones" id="autorizaciones">
      <label for="autorizaciones">Autorizaciones</label>
    </div>
  </div>


  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading"
      appPermissionControl="P201B0002">
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="abrirNiveles()"
      appPermissionControl="P201B0003">
      <mat-icon>layers</mat-icon>
      Niveles
    </button>
  </div>
</form>

<div id="recaptcha-container"></div>

<!-- Diálogo de Niveles -->
<p-dialog 
  [(visible)]="displayNivelesDialog" 
  [style]="{ width: '80vw', height: '80vh' }" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false" 
  (onHide)="cerrarNivelesDialog()" 
  header="Niveles de Usuario"
  [closable]="true"
>
  <app-user-niveles [usuarioData]="model"></app-user-niveles>
</p-dialog>